import {Platform, definePlatform} from './platform';

import {iosDevice} from './ios';
import {androidDevice} from './android';
import {defaultDevice} from './default';

function selectDevice(platform: Platform): DeviceService {
  const devices = {
    [Platform.Unknown]: defaultDevice,
    [Platform.Android]: androidDevice,
    [Platform.IOS]: iosDevice,
  };

  return devices[platform];
}

export const deviceService = selectDevice(definePlatform());
